var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonrise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 24.2053H22.6397C24.963 23.3803 27.092 22.0414 28.8869 20.2465C32.062 17.0714 33.8106 12.8499 33.8106 8.35958C33.8106 5.819 33.2573 3.37661 32.1659 1.10047C31.9931 0.74006 31.4685 0.739912 31.2957 1.10024C28.6733 6.56965 23.0619 10.1037 17.0001 10.1037C10.9383 10.1037 5.3271 6.56979 2.7045 1.10054C2.53328 0.743326 2.00781 0.738724 1.83436 1.10017C0.742902 3.37586 0.189453 5.81826 0.189453 8.35958C0.189453 12.8499 1.93805 17.0713 5.11312 20.2465C6.90803 22.0414 9.03714 23.3803 11.3603 24.2053H0.671875C0.40543 24.2053 0.189453 24.4213 0.189453 24.6877C0.189453 24.9542 0.40543 25.1701 0.671875 25.1701H33.3281C33.5946 25.1701 33.8105 24.9542 33.8105 24.6877C33.8105 24.4213 33.5946 24.2053 33.3281 24.2053ZM1.1543 8.36144C1.1543 6.30001 1.54038 4.30798 2.30335 2.42601C3.65139 4.84903 5.57914 6.90534 7.92594 8.41317C10.6317 10.1515 13.7695 11.0704 17 11.0704C20.2307 11.0704 23.3685 10.1515 26.0741 8.41317C28.4207 6.90549 30.3486 4.84896 31.6966 2.42616C32.4596 4.3085 32.8457 6.30053 32.8457 8.36151C32.8457 17.0988 25.7374 24.2071 17 24.2071C8.26267 24.2071 1.1543 17.0988 1.1543 8.36144Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonrise);
export default __webpack_public_path__ + "static/media/moonrise.f45e7579a9d920e08d5c8e97ba62ac76.svg";
export { ForwardRef as ReactComponent };